export default function ProcessPaymentIcon({
  width = 15,
  height = 13,
  color = "#fff",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6666 6.66667C12.3952 6.66667 13.0783 6.86147 13.6666 7.2018V2C13.6666 1.63181 13.3681 1.33333 12.9999 1.33333H7.27605L5.94272 0H0.999919C0.631732 0 0.333252 0.29848 0.333252 0.666667V11.3333C0.333252 11.7015 0.631732 12 0.999919 12H7.89419C7.74679 11.5829 7.66659 11.1342 7.66659 10.6667C7.66659 8.45753 9.45745 6.66667 11.6666 6.66667ZM9.30959 10.3098L11.6666 12.6668L14.9664 9.367L14.0236 8.42413L11.6666 10.7812L10.2524 9.367L9.30959 10.3098Z"
        fill={color}
      />
    </svg>
  );
}
